export function selectTheme() {
    if (process.env.REACT_APP_THEME?.toString() === "Allianz") {
        return require(__dirname + '/theme/Allianz/theme.scss');
    } else {
        return require(__dirname + '/theme/Flow/theme.scss');
    }
}



// WEBPACK FOOTER //
// ./src/ThemeUtils.ts